import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useUser } from "../../../context";
import { LOCALE_EN, LOCALE_FR } from "../../../const/const";
import { galleryVariants, GalleryConnector } from "../../../connectors/GalleryConnector";
import { aspectRatioMapping } from "../../../utils/Images/getAspectRatioMapping";
import { RCL as useTranslation } from "../../RCL";
import * as styles from "./PageBanner.module.scss";
import { useBreakpoints } from "../../../hooks";
import { LowestPriceCard } from "@sunwing/wvi-components";
import { GuestReview } from "../GuestReview/GuestReview";

const PageBanner = ({ data, price, locale }) => {
	const { affiliate } = useUser();
	const [aliasCode, setAliasCode] = useState("vwq");

	useEffect(() => {
		if (affiliate?.code) {
			setAliasCode(affiliate.code);
		}
	}, [affiliate]);

	const { isXs, isSm } = useBreakpoints();

	const translations = {
		beach: useTranslation({ searchKey: "beach" }),
		room: useTranslation({ searchKey: "room" }),
		entertainment: useTranslation({ searchKey: "entertainment" }),
		dining: useTranslation({ searchKey: "dining" }),
		pool: useTranslation({ searchKey: "pool" }),
		service: useTranslation({ searchKey: "service" }),
		basedOnNum: useTranslation({ searchKey: "based-on-numreviews-reviews" }),
		guestReview: useTranslation({ searchKey: "guest-review" }),
		days: useTranslation({ searchKey: "day-s" }),
		lowestPrice: useTranslation({ searchKey: "lowest-price" }),
		perAdult: useTranslation({ searchKey: "per-adult" }),
		bookLabel: useTranslation({ searchKey: "book" }),
	};

	const galleryAspectRatio = isXs || isSm ? aspectRatioMapping["1:1"] : aspectRatioMapping["16:9"];

	return (
		<div className={styles?.pageBanner}>
			{!!data.images?.length && (
				<GalleryConnector
					data={{
						images: data.images,
						galleryAspectRatio,
						variant: data.images?.length >= 5 ? galleryVariants.mosaic : galleryVariants.default,
					}}
					tags={data.tags}
				/>
			)}
			<div className={styles?.detailsContainer}>
				<div className={styles?.priceReviewContainer}>
					{!!price && (
						<LowestPriceCard
							link={{
								children: translations.bookLabel,
								href: `${price.deepLink}&alias=${aliasCode}`,
							}}
							price={{
								description: (
									<div>
										{translations.perAdult}
										<br /> {price.tax}.
									</div>
								),
								discount: price.regPrice,
								subtext: `${price.mealPlan} • ${price.duration} ${translations.days}`,
								value: price.price,
							}}
							tag={translations.lowestPrice}
							locale={locale}
						/>
					)}

					{!!data.numberOfReviews && <GuestReview data={data} translations={translations} />}
				</div>
			</div>
		</div>
	);
};

PageBanner.propTypes = {
	data: PropTypes.object,
	locale: PropTypes.oneOf([LOCALE_FR, LOCALE_EN]),
	price: PropTypes.shape({
		deepLink: PropTypes.string,
		duration: PropTypes.number,
		mealPlan: PropTypes.string,
		price: PropTypes.number,
		regPrice: PropTypes.number,
		tax: PropTypes.string,
	}),
};

PageBanner.defaultProps = {
	data: null,
	price: undefined,
	locale: LOCALE_EN,
};

export default PageBanner;
export { PageBanner };
